import type * as models from 'pkg/api/models';
import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Attachment } from 'pkg/api/models/attachment';
import type { Dateable } from 'pkg/api/models/dateable';
import type { Form } from 'pkg/api/models/form';
import type { FormEvent } from 'pkg/api/models/form_event';
import type { FormEventGroup } from 'pkg/api/models/form_event_group';
import type { Order } from 'pkg/api/models/order';
import type { Record } from 'pkg/api/models/record';
import type { User } from 'pkg/api/models/user';

export enum FormSubmissionInviteStatus {
	None = 'none',
	Invited = 'invited',
	Accepted = 'accepted',
	Rejected = 'rejected',
	Revoked = 'revoked',
	Assigned = 'assigned',
}

export enum Visibilities {
	Unlisted = 'unlisted',
	Public = 'public',
}

export enum FormSubmissionStatuses {
	Draft = 'draft',
	Submitted = 'submitted',
}

export interface SubmissionValue {
	attachmentId?: number;
	attachment?: Attachment;
	formFieldId: number;
	formFieldOptionId?: number;
	formSubmissionId: number;
	id: number;
	userId: number;
	value?: string;
}

export interface FormSubmissionEvent extends Record {
	formSubmissionEventGroupId: number;
	formEventId: number;

	formEvent?: FormEvent;
}

export interface FormSubmissionEventGroup extends Record {
	formSubmissionId: number;
	formEventGroupId: number;
	choseDates: boolean;

	formEventGroup?: FormEventGroup;
	formSubmissionEvents?: FormSubmissionEvent[];
}

export interface FormSubmission extends Record, Dateable, AllowedActionable {
	formId: number;
	userId: number;
	orderId: number;
	subscriptionId: number;
	data: { [key: string]: string };
	status: FormSubmissionStatuses;
	submittedAt?: number;
	submittedForUserId?: number;
	submittedByUserId?: number;
	targetGroupId?: number;

	formPackage?: models.formPackage.FormPackage;
	formPackageId?: number;

	attachments?: models.attachment.Attachment[];
	form?: Form;
	submittedForUser?: User;
	order?: Order;
	submittedByUser?: User;
	values: SubmissionValue[];
	inviteStatus?: FormSubmissionInviteStatus;
	targetGroup?: models.group.Group;
	submissionAgreements?: models.agreement.FormSubmissionAgreement[];
	eventGroups?: FormSubmissionEventGroup[];
}

export interface SubmissionUserData {
	userData: { [key: string]: any };
	attachments: { [key: number]: models.attachment.Attachment };
}
